<template>
  <div id="phb">
    <!-- 排行榜 -->
    <div class="content">
      <div class="ranking">
        <div class="phb-banner">
          <img
            src="https://i.tmuyun.com/webpic/W0202301/W020230109/W020230109693511434334.png"
            width="100%"
          />
        </div>
        <div class="phbHeader">
          <div
            class="headerBtn"
            :class="{ 'active-btn': currentType == 1 }"
            v-on:click="changeRanking(1)"
          >
            <span>村居榜</span>
          </div>
          <div
            class="headerBtn"
            :class="{ 'active-btn': currentType == 3 }"
            v-on:click="changeRanking(3)"
          >
            <span>学校榜</span>
          </div>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="onLoad"
        >
          <div class="van-clearfix">
            <div class="listHeader">
              <div class="headerTxt">{{ listHeadertitle1 }}</div>
              <div class="headerTxt">{{ listHeadertitle2 }}</div>
            </div>
            <div class="items">
              <div class="listItem" v-for="item in list" :key="item.id">
                <div class="itemTxt">{{ item.title }}</div>
                <div class="itemTxt">{{ item.rank }}</div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="phb-footer">
          <img
            src="https://i.tmuyun.com/webpic/W0202301/W020230109/W020230109706115089758.png"
            width="100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRankingList } from "@/api/fanzha";

export default {
  name: "Phb",
  data() {
    return {
      list: [],
      listHeadertitle1: "村居",
      listHeadertitle2: "参与人数",
      loading: false,
      finished: false,
      currentType: 1,
      themeId: 2,
    };
  },
  mounted() {},
  methods: {
    onLoad() {
      getRankingList({ type: this.currentType, themeId: this.themeId }).then(
        (res) => {
          if (res.code == 1) {
            for (let i = 0; i < res.data.length; i++) {
              this.list.push({
                id: res.data[i].id,
                title: res.data[i].title,
                rank: res.data[i].rank,
              });
            }
          }
          this.loading = false;
          this.finished = true;
        }
      );
    },
    changeRanking(type) {
      this.currentType = type;
      if (type == 1) {
        this.listHeadertitle1 = "村居";
        this.listHeadertitle2 = "参与人数";
      } else {
        this.listHeadertitle1 = "学校";
        this.listHeadertitle2 = "参与率";
      }
      this.list = [];
      this.onLoad();
    },
  },
};
</script>

<style lang="less" scoped>
.phb-banner {
  position: absolute;
  text-align: center;
  width: 60%;
  margin: auto;
  top: -30px;
  left: 50%;
  margin-left: -30%;
}
.phb-footer {
  position: absolute;
  text-align: center;
  width: 100%;
  margin: auto;
  bottom: -30px;
}
.ranking {
  position: relative;
  font-size: 14px;
  margin: 30px auto;
  background-color: #ffe9bb;
  padding-top: 45px;
  padding-bottom: 180px;
  width: 87%;
  border-radius: 10px;
  .listHeader {
    width: 90%;
    margin: 15px auto auto auto;
    color: #c2070a;
    display: flex;
    flex-direction: row;
    padding-bottom: 5px;
    border-bottom: 1px solid #c2070a;
    .headerTxt {
      width: 50%;
      text-align: center;
    }
  }
  .items {
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;

    .listItem {
      margin-top: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      color: black;
      .itemTxt {
        width: 50%;
        text-align: center;
      }
    }
  }
}
.phbHeader {
  width: 60%;
  display: flex;
  justify-content: space-between;
  line-height: 29px;
  margin: auto;
  .headerBtn {
    font-size: 13px;
    text-align: center;
    border-radius: 15px;
    background-color: #ffc78e;
    color: #c2070a;
    flex: 0 0 40%;
    span {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  .active-btn {
    background-color: #c2070a;
    color: #ffe9bb;
  }
}
</style>
